const eeWorkforceProfile = 'EmploymentEquity/WorkforceProfile';

export const GetWorkforceProfileGoalsAndTargets = eeWorkforceProfile;
export const SaveRow = `${eeWorkforceProfile}/SaveRow`;
export const GetComments = `${eeWorkforceProfile}/Comments`;
export const SaveComment = `${eeWorkforceProfile}/SaveComment`;
export const GetOccupationalLevelTables = `${eeWorkforceProfile}/GetOccupationalLevelTables`;
export const GetOccupationalLevelDrilldown = `${eeWorkforceProfile}/GetOccupationalLevelDrilldown`;
export const GetDisabledSummary = `${eeWorkforceProfile}/GetDisabledSummary`;
export const GetAppliedSectoralTargets = `${eeWorkforceProfile}/GetAppliedSectoralTargets`;
export const GetAllProvincesEAPTargets = `${eeWorkforceProfile}/GetAllProvincesEAPTargets`;
export const GetApplicableEAPYear = `${eeWorkforceProfile}/GetApplicableEAPYear`;